<app-loader [hidden]="!showLoader"></app-loader>
<app-section>
  <app-back-navigation-btn [routeUrl]="DASHBOARD_URL"></app-back-navigation-btn>
</app-section>
<app-component-seperator></app-component-seperator>
<app-section>
  <app-page-header *ngIf="header" [title]="header.depositName" [subTitle]="header.reportingName">
  </app-page-header>
</app-section>
<app-component-seperator></app-component-seperator>
<app-section>
  <div class="tab-section">
    <app-alert [alert]="alert"></app-alert>
    <form [formGroup]="cpqpReportForm" *ngIf="!isReportingCycleLocked && (cpqpReportForm && ((isAdmin) || (isCPQP && header.workflowStatus === '11'  && !isCompleteWorkflow)))">
      <app-form-header  [title]="'CP Report & Technical Report Summary'"></app-form-header>
      <div>
        <app-input-file [labelName]="'Upload document'" [submitted]="submittedcpqpReportForm"
          [inputFormControl]="cpqpReportForm?.controls?.file" [labelTextTransformNone]="true" (onFileSelect)="selectFile($event)" id="file">
        </app-input-file>
      </div>
      <div class="description">
        <app-input-textbox [labelName]="'Description'" [submitted]="submittedcpqpReportForm"
          [inputFormControl]="cpqpReportForm?.controls?.description">
        </app-input-textbox>
      </div>
      <div class="upload-button-style">
        <app-button (btnClick)="submitcpqpReportForm()" [type]="cpqpReportForm.valid?'primary':'secondary'" [name]="'Upload document'" [disable]="!cpqpReportForm.valid"></app-button>
      </div>
    </form>
    <app-form-header [title]="'Uploaded reports'"></app-form-header>
    <div class="usesrs-details">
      <app-workflow-table-grid [showrecord]="true" [headers]="cpQpReportHeaders" [data]="CpQpReportData"
        [noRecordTxt]="'No document record found.'" (onDelete)="onFileUploadDataDelete($event)"
        (onDownload)="downloadFile($event)" (onLink)="downloadFile($event)"></app-workflow-table-grid>
    </div>
    <div class="upload-button-style" *ngIf="header && header.isSubmitter === '1' && header.workflowStatus === '11' && CpQpReportData.length">
      <app-button [textTransformNone]="true"  (btnClick)="finalSubmitForReview()" [type]="'primary'" [name]="'Submit CP/QP Report'"></app-button>
    </div>
    <div *ngIf="alerts">
      <app-alert *ngFor="let alert of alerts" [alert]="alert"></app-alert>
    </div>
  </div>
</app-section>

<app-sticky-bottom-btns>
<app-section>
<app-button [name]="'Back to reporting Workflow'" [type]="'primary'" (btnClick)="BacktoManageWorkflow()"></app-button>
</app-section>
</app-sticky-bottom-btns>


<app-delete-confirmation-popup *ngIf="showDeletePopup" [message]="popupMessage" (onCancel)="closeDeletePopup()"
  (onDelete)="onDeleteUploadedDocument()"></app-delete-confirmation-popup>

<!-- <app-pop-up *ngIf="showUploadSuccessPopUp">
  <app-pop-up-header [headerName]="'Upload Successful'" (close)="closesuccessPopup()">
  </app-pop-up-header>
  <div class="comment" *ngIf="commentControl">
    <app-input-textarea [labelName]="'Add a comment'" [submitted]="submitCommentForm"
      [inputFormControl]="commentControl">
    </app-input-textarea>
  </div>
  <app-pop-up-footer>
    <app-button [name]="'Close'" [type]="'outlined'" (btnClick)="closesuccessPopup()"></app-button>
    <app-button [name]="'Add comment'" [type]="'primary'" (btnClick)="addComment()"></app-button>
  </app-pop-up-footer>
</app-pop-up> -->

<app-pop-up *ngIf="showApprovedPopup">
  <app-pop-up-header [showSuccessIcon]="true" [headerName]="'Submitted'"
    (close)="showApprovedPopup = !showApprovedPopup"></app-pop-up-header>

  <div class="comment">
    <span class="field-name">Acknowledgement has been saved.</span>
  </div>

  <app-pop-up-footer>
    <app-button [name]="'Go to workflows'" [type]="'primary'" (btnClick)="onBackToWorkFlow()"></app-button>
  </app-pop-up-footer>
</app-pop-up>



<app-pop-up *ngIf="showComments">
  <app-pop-up-header [textTransformNone]="true" [headerName]="'Comments(' + comments.length + ')'" (close)="showComments = !showComments"></app-pop-up-header>
  <div class="commentContainer">
    <div *ngIf="comments && comments.length" >
      <div class="commentList" *ngFor="let commentList of comments; let i = index">
        <span class="username">{{commentList.userName}}</span>
        <span class="updatedOn"> - {{commentList.updatedDate |date : 'medium'}}</span>
        <div class="commentStyle">{{commentList.comment}}</div>
        </div>
    </div>
    </div>
    <app-pop-up-footer>
      <app-button [name]="'Close'" [type]="'primary'" (btnClick)="showComments = !showComments"></app-button>
    </app-pop-up-footer>
  </app-pop-up>





